<script setup>
import { onMounted, ref, onBeforeUnmount, watch } from 'vue'
import intlTelInput from 'intl-tel-input'
import 'intl-tel-input/build/css/intlTelInput.css'

const props = defineProps({
  modelValue: String,
  placeholder: String,
  country: Object
})

const emits = defineEmits(['update:modelValue', 'setError', 'resetError', 'setCountry'])

const phoneInput = ref(null)
let iti = null

const updateValue = (event) => {
  if (event.target.value) {
    if (iti.isValidNumber()) {
      emits('resetError')
      let number = iti.getNumber().replace('+', '')
      let dialCodeLength = iti.getSelectedCountryData().dialCode.length
      console.log('test => ', number.substring(dialCodeLength))
      emits('update:modelValue', number.substring(dialCodeLength))

      const countryData = iti.getSelectedCountryData()
      if (countryData !== props.country) {
        emits('setCountry', countryData)
      }
    } else {
      emits('setError', 'Ongeldig nummer')
    }
  } else {
    emits('update:modelValue', '')
  }
}

onMounted(() => {
  iti = intlTelInput(phoneInput.value, {
    initialCountry: 'auto',
    preferredCountries: ['nl'],
    geoIpLookup: (callback) => {
      fetch('https://ipapi.co/json')
        .then((res) => res.json())
        .then((data) => callback(data.country_code))
        .catch(() => callback('us'))
    },
    utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@23.7.3/build/js/utils.js'
  })
})

watch(
  () => props.modelValue,
  (newValue) => {
    if (iti && newValue !== iti.getNumber()) {
      iti.setNumber(newValue)
    }
  }
)

onBeforeUnmount(() => {
  if (iti) {
    iti.destroy()
  }
})
</script>

<template>
  <div class="max-w-lg w-full">
    <input
      class="outline-none w-full bg-anti-flash-white rounded text-gray border-b-2 border-light-gray py-2.5 px-3"
      ref="phoneInput"
      :value="modelValue"
      @input="updateValue"
      type="tel"
      :placeholder="placeholder"
    />
  </div>
</template>

<style>
.iti {
  width: 100%;
}
</style>
